import React, { Component } from "react";
import { Bar } from "@ant-design/charts";
import { Radio, Typography, Popover, Button } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const { Text, Link } = Typography;

const importanceOptions = ["Top", "High", "Mid", "Low", "Unknown"];
const qualityOptions = [
  "FA",
  "GA",
  "A",
  "B",
  "C",
  "Start",
  "Stub",
  "FL",
  "List",
  "Unassessed",
];

const importanceDataset = (d) => {
  var data = [];
  importanceOptions.forEach((importance) => {
    const dataImportance = [
      {
        importance: importance,
        type: "+2 images",
        value: d.filter(function (article) {
          return article.n_images > 1 && article.importance == importance;
        }).length,
      },
      {
        importance: importance,
        type: "1 image",
        value: d.filter(function (article) {
          return article.n_images == 1 && article.importance == importance;
        }).length,
      },
      {
        importance: importance,
        type: "0 images",
        value: d.filter(function (article) {
          return article.n_images == 0 && article.importance == importance;
        }).length,
      },
    ];
    data = data.concat(dataImportance);
  });

  return data;
};

const qualityDataset = (d) => {
  var data = [];
  qualityOptions.forEach((quality) => {
    const dataQuality = [
      {
        quality: quality,
        type: "+2 images",
        value: d.filter(function (article) {
          return article.n_images > 1 && article.quality == quality;
        }).length,
      },
      {
        quality: quality,
        type: "1 image",
        value: d.filter(function (article) {
          return article.n_images == 1 && article.quality == quality;
        }).length,
      },
      {
        quality: quality,
        type: "0 images",
        value: d.filter(function (article) {
          return article.n_images == 0 && article.quality == quality;
        }).length,
      },
    ];
    data = data.concat(dataQuality);
  });

  return data;
};

export default class BarChartArticles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barValue: "importance",
    };
  }
  onChangeBar = (e) => {
    this.setState({
      barValue: e.target.value,
    });
  };

  data = (d) => {
    if (this.state.barValue == "importance") {
      return importanceDataset(d);
    } else {
      return qualityDataset(d);
    }
  };

  popOverContent = (<Text>asdasdasd</Text>);

  render() {
    const { barValue } = this.state;

    const config = {
      data: this.data(this.props.data),
      isStack: true,
      xField: "value",
      yField: barValue,
      seriesField: "type",
      color: ["#40A9FF", "#91D5FF", "#FF7875"],
      legend: {
        position: "top",
      },
      label: null,
    };

    return (
      <>
        <div className="chart-title">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text strong>
              Number of articles per {barValue}{" "}
              <Popover
                content={
                  <Text>
                    Following the{" "}
                    <Link
                      href="https://en.wikipedia.org/wiki/Wikipedia:Content_assessment#Grades"
                      target="_blank"
                    >
                      content assessment grades
                    </Link>{" "}
                    of Wikipedia
                  </Text>
                }
              >
                <Button
                  type="link"
                  shape="circle"
                  icon={<QuestionCircleOutlined />}
                />
              </Popover>
            </Text>
            <Radio.Group onChange={this.onChangeBar} value={barValue}>
              <Text style={{ marginRight: "20px" }}>Group by:</Text>
              <Radio value={"importance"}>Importance</Radio>
              <Radio value={"quality"}>Quality</Radio>
            </Radio.Group>
          </div>
        </div>
        <Bar {...config} />
      </>
    );
  }
}
